export { TipCard } from './TipCard'
